module.exports = __webpack_public_path__ + "img/wen.1f5c3ae4.png";